import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { loading: false, data: [], error: "", message: "" }



export const getSingleQuestionAnswerAction = createAsyncThunk(
    'get-single-question-answer',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/admins/api/get-single-question-answer/${data}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getSingleQuestionAnswerSlice = createSlice({
    name: 'get-single-question-answer',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getSingleQuestionAnswerAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(getSingleQuestionAnswerAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.message = action?.payload?.message
            })

            builder.addCase(getSingleQuestionAnswerAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.message = action?.payload?.message
            })
        },
})



export const getSingleQuestionAnswerReducer = getSingleQuestionAnswerSlice.reducer